import { render, staticRenderFns } from "./AmbankForm.vue?vue&type=template&id=4c587bfc"
import script from "./AmbankForm.vue?vue&type=script&lang=js"
export * from "./AmbankForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports